import React from "react";
import { ChartsSetWrapperNew } from "../../../../../components";
import { chartAdvDataNew } from "./data";

const PieDonutListAdv = () => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <ChartsSetWrapperNew
        title="Pie Chart"
        type="pie"
        data={chartAdvDataNew.series}
        categories={chartAdvDataNew.categories}
      />
      <ChartsSetWrapperNew
        title="Donut Chart"
        type="pie"
        data={chartAdvDataNew.series}
        categories={chartAdvDataNew.categories}
        options={{
          pie: {
            innerRatio: 0.6,
          },
        }}
      />
    </div>
  );
};

export default PieDonutListAdv;
